<template>
  <div>
      <section class="fluxo">
        <div class="container">
        <div class="row ">
          <div class="col-12 col-md-12 col-lg-9 mx-auto">
            <p>A Adesão é uma ferramenta que disponibilizamos para acesso aos serviços de API e RPA disponíveis e existentes para corretores cadastrados na Tokio Marine.</p>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-center">
            <div class="menu mt-4 mb-4">
              <button :class="{ active: isActive[0] }" @click.prevent="toggleButton(0)">VENDAS</button>
              <button :class="{ active: isActive[1] }" @click.prevent="toggleButton(1)">RPA</button>
              <button :class="{ active: isActive[2] }" @click.prevent="toggleButton(2)">GESTÃO CARTEIRA</button>
              <button :class="{ active: isActive[3] }" @click.prevent="toggleButton(3)">PÓS VENDA</button>
            </div>    
          </div>
        </div>
        <div class="row">
          <div class="col">
            <component :is="currentComponent"></component>
          </div>
        </div>
      </div>
      </section>
  </div>
</template>

<script>

import Vendas from '@/views/fluxo/adesao/Vendas.vue';
import Rpa from '@/views/fluxo/adesao/Rpa.vue';
import Gestao from '@/views/fluxo/adesao/Gestao.vue';
import PosVenda from '@/views/fluxo/adesao/PosVenda.vue';

export default {
  data() {
    return {
      currentComponent: null,
      isActive: [true, false, false, false]
    };
  },

  mounted() {
    this.changeComponent(Vendas);
  },
  computed: {

  },
  methods: {

    async changeComponent(componentName) {
      try {
        switch (componentName) {
          case Vendas:
            this.currentComponent = Vendas;
            break;
          case Rpa:
            this.currentComponent = Rpa;
            break;
          case Gestao:
            this.currentComponent = Gestao;
            break;
          case PosVenda:
            this.currentComponent = PosVenda;
            break;
        }
      } catch (error) {
        console.error(`Erro ao carregar o componente '${componentName}':`, error);
      }
    },

    toggleButton(index) {
      this.isActive = this.isActive.map((_, i) => i === index);

      if (index === 0) {
        this.changeComponent(Vendas)
      } else if (index === 1) {
        this.changeComponent(Rpa)
      } else if (index === 2) {
        this.changeComponent(Gestao)
      } else {
        this.changeComponent(PosVenda)
      }
    }
  }
};
</script>
